import React from 'react';
import logo from './EN.png'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { useContext,useEffect } from 'react';
import Col from 'react-bootstrap/Col';
import AboutUs from '../../components/aboutUs/AboutUs';
import '../../components/aboutUs/aboutUs.scss'

import { AuthContext } from "../../context/authContext";

function About(props) {
    return (
        <div style={{textAlign:'center'}}>
              <Container>
                <Row>
                    <h1  className="about-title" style={{marginTop:'2%',fontSize: "42px"}}>Інформаційна система підтримки українців, що подорожують з хатніми тваринами</h1>
                </Row>
                <Row>
                    <Col>
                    <div>
            <img src={logo} style={{width:'50vh'}}/>
            </div>
                    </Col>
                    <Col style={{margin:'auto', background: `radial-gradient(ellipse at top right, yellow, yellow 20%, transparent 20%)`, backgroundSize: `200% 200%`}}>
                    <p >Сайт розроблено в рамках реалізації проекту Ерасмус+ Модуль Жана Монне “Інтеграція політики та засад Єдиного Здоров'я ЄС в Україні” (101048229 — EU4OH — ERASMUS–JMO–2021–HEI–TCH–RSCH) за підтримки Європейського Союзу."</p>
            <p>The site was developed in the framework of the Erasmus+ Jean Monnet project “Integration EU One Health framework and policies in Ukraine” (101048229 — EU4OH — ERASMUS–JMO–2021–HEI–TCH–RSCH) co-funded by the European Union.</p>
                    </Col>
                </Row>
   
           
            
            <AboutUs/>
            </Container>
        </div>
    );
}

export default About;